import React, { useState, useEffect } from "react";

function Partner() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    // ✅ Partner images (from your HTML snippet)
    const data = [
      "partner-1.png",
      "partner-2.png",
      "partner-3.png",
      "partner-4.png",
      "partner-5.png",
      "partner-6.png",
      "partner-7.png",
      "partner-8.png",
      "partner-9.png",
      "partner-10.png",
      "partner-11.png",
      "partner-12.png",
      "partner-15.png",
      "partner-13.png",
      "partner-14.png",
    ].map((file, idx) => ({
      id: idx + 1,
      img: `img/partners/${file}`,
    }));

    setPartners(data);
  }, []);

  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-partner.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Partners</h1>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Partners</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Partner Cards Section */}
      <section>
        <div className="container">
          <div
            className="mb-1-6 mb-lg-5 image-hover wow fadeInUp"
            data-wow-delay="100ms"
          >
            <p className="mb-2 font-weight-700 text-dark">
              We express heartfelt gratitude for the unwavering support and
              collaboration of our valued funders and partners, who are
              instrumental in advancing our mission to build a better society.
              Together, we strive to create meaningful change, improving the
              lives of those who need our services most.
            </p>
          </div>

         {/* Partner logos grid */}
        <div className="row mt-n1-9">
          {partners.map((partner) => (
            <div
              className="col-lg-6 col-xl-2 mt-1-9 wow fadeInUp"
              data-wow-delay="100ms"
              key={partner.id}
            >
              <div className="d-flex">
                <div className="flex-grow-1">
                  <img src={partner.img} alt={`Partner ${partner.id}`} />
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
}

export default Partner;
